<div class="service">
    <div class="service-title">
        <span class="service-title-text">Tilføj Service</span>
        <counter></counter>
    </div>
    <collapsible-grid title="Kalibrering" subtitle="Interval" text="1 år"></collapsible-grid>
    <collapsible-grid title="Vedligeholdelse" subtitle="Interval" text="3 mdr"></collapsible-grid>
    <collapsible-grid title="Eftersyn" subtitle="Interval" text="1 år"></collapsible-grid>
    <icon-text-button icon="circle-plus" text="Tilføj Service"></icon-text-button>
</div>